// Each document owns its Quill constructors/plugins. Never borrow the parent's DOM-bound editor.
let pending: Promise<void> | null = null;
let loaded = false;
let nextAsset = 0;

/** null means the page supplied eager assets, or its deferred sequence has finished. */
export function loadQuillAssets(): Promise<void> | null {
    const island = document.getElementById('ft-quill-assets');
    if (!island || loaded) return null;
    if (pending) return pending;
    const urls = JSON.parse(island.textContent || '[]') as string[];
    pending = (async () => {
        while (nextAsset < urls.length) {
            const src = urls[nextAsset]!;
            await new Promise<void>((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => resolve();
                script.onerror = () => {
                    script.remove();
                    reject(new Error('Could not load editor asset: ' + src));
                };
                document.head.appendChild(script);
            });
            nextAsset++;
        }
        loaded = true;
    })().finally(() => { pending = null; });
    return pending;
}
